export enum INVESTIGATION_STANDARDS {
  TEXAS = 'TX',
  NGSS = 'NGSS',
}
